<template>
  <div id="box">
    <a-card style="box-sizing:border-box;border-radius: 0 !important;">
      <div class="wps" :style="{background:'#f0f2f5'}">
        <div class="biaoti">
          <div class="boxw">
            <img :src="httplogo" width="100px" height="100px" style="margin-top: -14px;  padding-right: 10px"/>
          </div>
          {{configdata.projectname}}
        </div>
      </div>
      <!-- 未配置支付方式提示框 -->
      <a-divider v-if="!appId">请选择应用APPID</a-divider>
      <a-divider v-else-if="noConfigText">您尚未配置任何支付方式</a-divider>
      <!--      <a-divider v-else></a-divider>-->

      <!-- 支付测试面板 v-if=""-->
      <div style="width: 100%;" class="paydemo" v-if="payTestShow()">
        <div class="paydemo-type-content">
          <div class="paydemo-type-name article-title" v-show="showTitle('WX')">微信支付</div>
          <div class="paydemo-type-body">

            <div class="paydemo-type color-change" v-show="appPaywayList.indexOf('WX_NATIVE') >= 0"
                 @click="changeCurrentWayCode('WX_NATIVE', 'codeImgUrl')"
                 :class="{this:(currentWayCode === 'WX_NATIVE')}">
              <img src="@/assets/payTestImg/wx_native.svg" class="paydemo-type-img"><span
                class="color-change">微信二维码</span>
            </div>

            <div class="paydemo-type color-change" v-show="appPaywayList.indexOf('WX_BAR') >= 0"
                 @click="changeCurrentWayCode('WX_BAR', '')" :class="{this:(currentWayCode === 'WX_BAR')}">
              <img src="@/assets/payTestImg/wx_bar.svg" class="paydemo-type-img"><span class="color-change">微信条码</span>
            </div>

            <div class="paydemo-type color-change" v-show="appPaywayList.indexOf('WX_JSAPI') >= 0"
                 @click="changeCurrentWayCode('WX_JSAPI', 'codeImgUrl')"
                 :class="{this:(currentWayCode === 'WX_JSAPI')}">
              <img src="@/assets/payTestImg/wx_jsapi.svg" class="paydemo-type-img"><span
                class="color-change">公众号/小程序</span>
            </div>

            <div class="paydemo-type-h5" v-show="appPaywayList.indexOf('WX_H5') >= 0"
                 @click="changeCurrentWayCode('WX_H5', 'payurl')" :class="{this:(currentWayCode === 'WX_H5')}">
              <img src="@/assets/payTestImg/wx_h5.svg" class="paydemo-type-img"><span class="color-change">微信H5</span>
            </div>
          </div>

          <a-row style="margin-bottom: 20px">
            <a-col :span="24" style="text-align: center">
              <img :src="configdata.usbkeyimg" width="250px" height="90px"/>
<!--              <img src="http://shopping.xakxzc.com/img/key.3658f57d.png" width="250px" height="90px"/>-->
            </a-col>
          </a-row>

          <a-row>

          </a-row>

          <a-row>
            <a-col :span="12">

              <a-form :form="form" :label-col="{ span: 5}" :wrapper-col="{ span: 18}" @submit="handleSubmit">

                <a-form-item label="购买项目">



                  <a-radio-group name="radioGroup" :default-value="1">
                    <a-radio :value="1">介质<span style="color: red">￥{{ tobonumber }}<i style="color:#999;text-decoration:line-through;font-size: 8px;">（原价49）</i></span>
                    </a-radio>
                  </a-radio-group>


                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>灌装流程说明：企业在此下单后，请再自行前往证书运维管理平台上提交证书申请。</span>
                    </template>
                    <a-radio-group name="radioGroup" :default-value="1">
                      <a-radio :value="1">
                        灌装代办<span style="color: red">￥{{ tobonum }}<i style="color:#999;text-decoration:line-through;font-size: 8px;">（原价24）</i></span>
                      </a-radio>
                    </a-radio-group>
                  </a-tooltip>


<!--                  defaultChecked    defaultValue :defaultChecked="checkeddef" -->
                  <a-checkbox  :checked="checkeddef" @change="onChange1">
                    省心服务(介质灌装完成邮寄到手)<span style="color: red">￥{{ Byyouji }}</span>
                  </a-checkbox>

                  <a-checkbox checked="checkeddef" >含一年技术服务</a-checkbox>



                </a-form-item>


                <a-form-item label="购买数量">
                  <a-input-number id="inputNumber" v-decorator="['totalnum', { initialValue:1,rules: [{ required: true, message: '购买数量!' }] }]" :min="1" :max="100" @change="onChanges"/>
                </a-form-item>

                <a-form-item label="购买单位">
                  <a-input
                      placeholder="请输入购买单位全称"
                      v-decorator="['company', { rules: [{ required: true, message: '请输入购买单位!' }] }]"
                  />
                </a-form-item>

                <a-form-item label="信用代码">
                  <a-input
                      placeholder="请输入统一社会信用代码"
                      v-decorator="['yscode',validatorRules.yscode, { rules: [{ required: true, message: '请输入统一社会信用代码!' }] }]"
                  />
                </a-form-item>

                <a-form-item label="经办人">
                  <a-input
                      placeholder="请输入经办人姓名"
                      v-decorator="['name', { rules: [{ required: true, message: '请输入经办人!' }] }]"
                  />
                </a-form-item>
                <a-form-item label="手机号码">
                  <a-input
                      placeholder="请输入11位手机号码"
                      v-decorator="['phone',validatorRules.phone, { rules: [{ required: true, message: '请输入手机号码!' }] }]"
                  />
                </a-form-item>


              </a-form>

            </a-col>
            <a-col :span="12">
              <div>

                <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-form-item label="是否开票">
                    <div style="display: flex;align-items: baseline">
                      <a-radio-group name="radioGroup" v-model="valueaw" :default-value="2" style="margin-top: 8px">


                        <a-tooltip placement="top">
                          <template slot="title">
                            <span>发票一到三个工作日，会发到您填写的邮箱</span>
                          </template>
                          <a-radio :value="1">
                            是
                          </a-radio>
                        </a-tooltip>

                        <a-radio :value="2" disabled="true">
                          否
                        </a-radio>
                      </a-radio-group>
                      <div v-if="valueaw==1" style="margin-left: 10px">仅支持电子增值税普通发票</div>
                      <div v-if="valueaw==2" style="margin-left: 10px">           　</div>
                    </div>


                  </a-form-item>

                  <a-form-item label="电子邮箱" >
                    <a-input v-decorator="['email',validatorRules.email, ]" placeholder="请输入用于接收电子发票有效邮箱"
                    />
                  </a-form-item>

                  <a-form-item label="购方名称" v-if="valueaw==1">
                    <a-input disabled
                             v-decorator="['company', { rules: [{ required: true, message: '请输入购买单位!' }] }]"
                    />
                  </a-form-item>

                  <a-form-item label="购方名称" v-if="valueaw==2">
                    <a-input disabled
                             v-decorator="['company',]"
                    />
                  </a-form-item>

                  <a-form-item label="购方税号" v-if="valueaw==1">
                    <a-input disabled  v-decorator="['yscode', { rules: [{ required: true, message: '请输入统一社会信用代码!' }] }]"/>
                  </a-form-item>

                  <a-form-item label="购方税号" v-if="valueaw==2">
                    <a-input disabled
                             v-decorator="['yscode', ]"
                    />
                  </a-form-item>

<!--                  <a-form-item label="地址、电话" v-if="valueaw==1">-->
<!--                    <a-input-->
<!--                        v-decorator="['address', { rules: [{ required: true, message: '请输入地址、电话!' }] }]"-->
<!--                    />-->
<!--                  </a-form-item>-->


                  <a-form-item label="地址、电话" >
                    <a-input
                        v-decorator="['address', ]"
                    />
                  </a-form-item>


<!--                  <a-form-item label="银行、账号" v-if="valueaw==1">-->
<!--                    <a-input-->
<!--                        v-decorator="['bank', { rules: [{ required: true, message: '请输入银行、账号!' }] }]"-->
<!--                    />-->
<!--                  </a-form-item>-->
                  <a-form-item label="银行、账号" >
                    <a-input

                        v-decorator="['bank',]"
                    />
                  </a-form-item>


                </a-form>
              </div>

            </a-col>
          </a-row>

          <a-row style="margin-top: 35px">

            <a-col :span="24">
              <div style="width: 500px;margin: auto;text-align: center">

                <a-form id="ok" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-form-item label="       ">
                    <a-checkbox style="margin-right: 10px" v-model="checked" @change="onChangeqw">
                    </a-checkbox>
                    我已认真阅读并同意 <span :style="radioStyle " @click="boglook">服务协议</span>

                  </a-form-item>
                </a-form>
              </div>
            </a-col>
          </a-row>

<!--          <div id="righttoobar" style="position: fixed;right: 1px;top:40%;display: flex;flex-direction: column">-->
<!--            <a-button  style="font-size: 15px;margin-top: 20px;background: #0066CC;color: #fff;border-color:#0066CC "  @click="handleSubmits">-->
<!--              查询订单-->
<!--            </a-button>-->
<!--            <a-button style="font-size: 15px;margin-top: 20px;background: #CC0033;color: #fff;border-color:#CC0033 " type="warning" @click="handleSubmits">-->
<!--              订单退款-->
<!--            </a-button>-->

<!--            <a-button  style="font-size: 15px;margin-top: 20px;background: #FF9933;color: #fff;border-color:#FF9933 " type="warning" @click="dialogVisible=true">-->
<!--              智能图片处理-->
<!--            </a-button>-->
<!--          </div>-->

          <div style="display: flex;flex-direction: row;justify-content: center">
            <a-button :disabled="disabledlook" style="font-weight:bold;width: 200px;height: 40px;font-size: 15px" type="primary"
                      @click="handleSubmit">
              提交订单
            </a-button>
          </div>

          <div id="bottomtoolbar" style="display: flex;flex-direction: row;align-items: center;justify-content: center">
            <a-button id="btnorder"  style="font-weight:normal;font-size: 13px;margin-top: 20px;background: #5f9ea0;color: #fff;border-color:#5f9ea0 "  @click="handleSubmits">
              查询订单
            </a-button>
            <a-button id="btnseal" style="font-weight:bold;font-size: 13px;margin: 20px 10px 0;background: #FF9933;color: #fff;border-color:#FF9933;" type="warning" @click="dialogVisible=true">
              智能图片处理
            </a-button>
            <a-button id="btnrefund" style="font-weight:normal;font-size: 13px;margin-top:20px;background: #f0f2f5;color: #333;border-color:#f0f2f5 " type="warning" @click="handleSubmits">
              申请退款
            </a-button>


          </div>

          <el-dialog
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              title="智能图片处理"
              :visible.sync="dialogVisible"
              width="30%"
          >
            <div id="successbox">
              <div class="infotip">在本系统下单购买证书后，须自行登录{{configdata.certplatformtitle}}提交证书申请。
                您可以<span @click="openyw" style="color: #1A53FF;cursor: pointer;">点击此处</span>跳转到{{configdata.certplatformtitle}}。
              </div><div class="infotip">
                提交证书申请后，还须在{{ configdata.certplatformtitle }}提交电子签章所需的公章图片。专业的图像处理软件处理图章耗时且操作繁杂，如果您需要人工智能自动化图章处理（自主操作，使用简单，安全可靠，5秒出图），请
                <span @click="openseal" style="color: red;cursor: pointer;">点击此处</span>
                前往购买。</div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </a-card>
    <a-modal
        title="阅读条款"
        :visible="visible"
        width="50%"
        :destroyOnClose="true"
        :confirm-loading="confirmLoading"
        @cancel="handleCancel"

        :maskClosable="false"
    >
      <div style="text-align: center;font-weight: 800">
        <h1>委托服务协议</h1>
      </div>
      <div>
        <p>
          <b>
            委托方：{{ companyname }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            信用代码：{{ companyyscode }}
          </b>
        </p>
      </div>
      <div>
        <p>
          <b>受托方：{{ configdata.companytitle }}</b>
        </p>
      </div>

      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;鉴于：受托方系医保标准数字证书存储介质的授权提供商。委托方为了工作便利，自愿付费向受托方采购符合{{configdata.province}}医保标准规范的数字证书存储介质（以下简称“KEY”），并委托受托方为其代为办理以下事宜：</p>
      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;<b>1、由受托方向相关管理单位申请灌装委托方医保数字证书；</b></p><br>
      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;<b>2、受托方<b v-if="sendmethod==1">择优选择快递公司</b>将灌装好的医保数字证书<b v-if="sendmethod==1">邮寄至委托方公司所在地。</b><b v-if="sendmethod==2">现场移交给委托方</b> </b></p><br>
<!--      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;委托服务费用：<b>免费（不含快递费）</b></p><br>-->
      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;服务有效期：<b>自签订本协议之日起至委托方收到医保数字证书之日止</b></p><br>
      <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备注：灌装医保数字证书所需要的相关材料由委托方自行向相关管理单位提交，委托方收到灌装好的医保数字证书后自行保管KEY，若因委托方提交材料不合格导致无法或延期灌装，或KEY丢失、损坏等原因造成的损失由委托方自行承担。</p>
      <br>
      <!--        <div v-show="vshow">-->
      <!--          <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;贵公司的技术支持服务截止时间为 &nbsp;<b style="color: red">{{outtime}}</b>，技术支持服务已过期，为了方便您的使用，建议购买技术服务，技术支持服务收费标准：<b style="color: red">98元/年</b>。-->
      <!--          <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;技术支持服务内容：数字证书使用咨询，数字证书使用问题处理。技术支持服务方式：电话或远程支持</p>-->
      <!--        </div>-->
      <p></p><br>
      <p></p><br>
      <div style="display: block;overflow: hidden; margin-bottom: 25px;padding-left: 70px;box-sizing: border-box">
        <div style="float: left">
          <p>委托方：<b>{{ companyname }}</b></p>
          <p>&nbsp;&nbsp;&nbsp;日期：<b>{{ year }}年{{ month }}月{{ dates }}日</b></p>
        </div>
        <div style="float:right;padding-right: 70px; box-sizing: border-box">
          <p>受托方：<b>{{ configdata.companytitle }}</b></p>
          <p>&nbsp;&nbsp;&nbsp;日期：<b>{{ year }}年{{ month }}月{{ dates }}日</b></p>
        </div>
      </div>
      <template #footer>
        <a-button :disabled="disabled" type="primary" @click="handleOk">{{ valiBtn }}</a-button>
      </template>
    </a-modal>


    <a-modal
        title="技术支持服务"
        :visible="visiblelook"
        width="50%"
        :destroyOnClose="true"
        :confirm-loading="confirmLoading"
        @cancel="handleCancellook"
        :maskClosable="false"
    >
      <div style="text-align: center;font-weight: 800">
        <h1>技术支持服务</h1>
      </div>

      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;贵公司的技术支持服务截止时间为 &nbsp;<b style="color: red">{{ outtime }}</b>，技术支持服务已过期，为了方便您的使用，建议购买技术服务，技术支持服务收费标准：<b
          style="color: red">98元/年</b>。
      <p> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;技术支持服务内容：数字证书使用咨询，数字证书使用问题处理。技术支持服务方式：电话或远程支持</p>

      <p></p><br>
      <p></p><br>


      <template #footer>
        <a-button :disabled="disabled" type="primary" @click="handleOklook">同意购买技术服务</a-button>
      </template>

    </a-modal>

    <a-modal v-model="visiblemodd" width="40%" title="流程说明" @ok="handleOkmodd">
      <p> <b>灌装流程说明：企业在此下单后，请再自行前往证书运维管理平台上提交证书申请。</b></p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </a-modal>

    <!-- 二维码弹窗 -->
    <pay-test-modal ref="payTestModal" @closeBarCode="$refs.payTestBarCode.visible = false"></pay-test-modal>

    <!-- 条码弹框 -->
    <pay-test-bar-code ref="payTestBarCode" @barCodeValue="barCodeChange"
                       @CodeAgainChange="testCodeChange"></pay-test-bar-code>


    <div class="position" v-if="sssvisiblesss">
      <div class="position_cont">
        <div class="position_conttit">购买须知</div>
        <div class="position_content">{{ configdata.notice }}</div>
        <div class="position_contbot">
          <span @click="handleCancesl" style="cursor:pointer;">
            {{ buttso }}
          </span>
        </div>
      </div>
    </div>

    <div class="position" v-if="Tips">
      <div class="position_cont">
        <div class="position_conttit">温馨提示</div>
        <div class="position_content">省心服务可以帮您提供申请、罐装、邮寄的一站式服务，放弃省心服务可能无法及时获得CA证书，请再次确认是否放弃订购！</div>
        <div class="position_contbot">
          <span @click="handleCanceslgiveup" style="cursor:pointer;margin-right:15px;background:#eeeeee;">放弃订购</span>
          <span @click="handleCanceslcontinue" style="cursor:pointer;background:#67c23a;">继续订购</span>
        </div>
      </div>
    </div>



    <div style="background:#f0f2f5;height: 100px;text-align: center;justify-content:center;width: 100%; display: flex;flex-direction: row;align-items: center">
      <div style="display: flex;">
        <img :src="policeimg" style="margin-right: 10px;"> {{configdata.sitebeian}}</div>
      <div style="width:50px;"></div>
      <div> <a-icon type="mail" theme="twoTone"  :style="{ fontSize: '14px', color: '#08c' }"/> 邮箱：<b  style="color: #1890ff;  cursor: pointer; " @click="youxiang">{{configdata.maile }}</b></div>
      <div style="width:50px;"></div>
      <div style="font-weight: bold"> <b style="margin-right: 5px">客服电话 </b>：<span style="color: rgb(24, 144, 255)">{{configdata.servicephone}}</span></div>
    </div>

    <div  style="display:flex;flex-direction:column;position: fixed;right: 25px;bottom: 150px;width: 100px;overflow: hidden;cursor: pointer;" @click="Gokefu">
      <img :src="icon_ren" style="width: 100px;height:90px;margin:10px auto 10px; ">
      <span style="display:block;text-align:center;margin:0 auto;width:80px;height: 30px;line-height: 30px;font-size: 14px;color: #fff;background:  rgb(24, 144, 255);border-radius:5px;">在线客服</span>
    </div>

  </div>
</template>

<script>
import {
  company_servicetime,
  order_orderList,
  payTest,
  payTestOrder,
  price_getPrice,
  price_getPriceByyouji,
  getpricelist
} from '@/api/manage' // 接口~
import PayTestModal from './PayModal' // 二维码对话框组件
import PayTestBarCode from './PayBarCode' // 条码对话框组件
import {Carousel} from 'ant-design-vue'
import {conf_list, getPriceBydaiban} from "../../api/manage";

import policeimg from '@/assets/police.png'
import icon_ren from "@/assets/icon_kefu.gif";
export default {
  name: 'paytest',
  props: {},
  components: { PayTestModal, PayTestBarCode, Carousel },
  data () {
    return {
        httplogo:'',
      policeimg:policeimg,
      icon_ren:icon_ren,
      dialogVisible:false,
      sssvisiblesss:true,
      visiblemodd:false,
      // urlop:'images/93750.png',

      checked1: false,
      form: this.$form.createForm(this,
          { name: 'coordinated', }
      ),
      dialogStyle:{
        top:'40%'
      },
      validatorRules: {
        phone: {//name与v-decorator中属性对应
          rules: [
            { required: true, message: '请输入手机号码!' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!' },//此处配置正则表达式，手机号，可自己配置正则表达式
          ]
        },
        yscode: {//name与v-decorator中属性对应
          rules: [
            { required: true, message: '请输入统一社会信用代码!' },

          ]
        },
        email: {//name与v-decorator中属性对应
          rules: [
            { required: true, message: '请输入正确的邮箱!' },
            { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/, message: '请输入正确的邮箱!' },//此处配置正则表达式，手机号，可自己配置正则表达式
          ]
        },
      },
      // imgurl: require('@/assets/images/key.png'),
      imgurl: "",
      // imgurlas: require('@/assets/images/93750.png'),
      imgurlas: "",
      imgbg: require('@/assets/images/topbg.jpeg'),
      mchAppList: [], // app列表
      appId: '2021003131636388', // 已选择的appId
      appPaywayList: ['ALI_QR'], // 商户app支持的支付方式
      currentWayCode: 'ALI_QR', // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: '', // 支付参数
      mchOrderNo: '', // 模拟商户订单号
      authCode: '', // 条码的值
      companyyscode: '',
      paytestAmount: '0.01', // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: '接口调试', // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabled: false,
      disabledlook: false,
      visibletongzhi:false,
      visiblelook: false,
      valueaw: 1,
      valiBtn: '同意条款',
      buttso:'我已知晓',
      ModalText: '阅读协议，哈哈首科大厦大家安康',
      visible: false,
      visiblelx: false,
      companyname: '',
      confirmLoading: false,
      radioStyle: {
        cursor: 'pointer',
        marginleft: '10px',
        height: '30px',
        lineHeight: '30px',
        color: '#132b75',
      },
      mpd:null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonum:null,
      Byyouji:null,
      number: {
        value: 11,
      },
      Tips:false,
      pricelist:[],
      configdata:{},
      timewo:null,
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      projectname:'',
      xmalimg:'',
      usbkeyimg:'',
    }
  },
  created () {
      this.httplogo = "/imgs/" + window.location.hostname + "/logo.png"
    let time = 5
    this.btnTime = setInterval(() => {
      if (time == 0) {
        clearInterval(this.btnTime)
        this.timewo = 0
        this.buttso = '我已知晓'
        // this.sssvisiblesss = false
      } else {
        this.sssvisiblesss = true
        this.buttso = '我已知晓' + time
        time--
      }
    }, 1000)


    price_getPrice({}).then(response => {
      // console.log(response)
      this.tobonumber = response.data.price

    })
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
    localStorage.setItem('serviceurl',  configdata.serviceurl);


    getPriceBydaiban({}).then(response => {
      // console.log(response)
      this.tobonum = response.data.price

    })

    //price_getPriceByyouji
    price_getPriceByyouji({}).then(response => {
      this.Byyouji = response.data.price

    })
    const date = new Date()
    this.year = date.getFullYear()
    this.month = date.getMonth() + 1
    this.dates = date.getDate()
  },

  mounted () {
    // 获取传入的参数，如果参数存在，则为appId 重新赋值
    const appId = this.$route.params.appId
    if (appId) {
      this.appId = appId // appId赋值
      this.appPaywayListHandle(appId) // 调用appPaywayListHandle，展示支付方式
    }
    const that = this // 提前保留this
    this.randomOrderNo();
    getpricelist({}).then(response => {
      this.pricelist = response.data

    })
  },

  methods: {
    Gokefu(){//customer
        window.open(localStorage.getItem('serviceurl'),'_blank')
    },
    youxiang(){
      // console.log("65565")
      window.open('https://qy.163.com/login/?from=ym')
    },
    openseal(){
      window.open('/seal/index','_blank')
    },
    openyw(){window.open(this.configdata.certplatformurl,'_blank')},
    handleSubmitsks() {
      this.visiblelx = true;
    },
    handleOklx(e) {
      this.visiblelx = false;
    },

    handleCancesl(){
      if(this.timewo == 0){
        console.log("进来了")
        this.sssvisiblesss = false
      }
    },
    handleOkmodd(e) {
      console.log(e);
      this.visiblemodd = false;

    },

    onChange1 (e) {
      this.checkeddef = e.target.checked
      this.sendmethod = e.target.checked ? 1 : 2
      this.mpd = e.target.checked
      console.log(e.target.checked,e.target.checked)
      if(e.target.checked == false ){
        this.Tips = true
      }else{
        this.Tips = false
      }
    },
    handleCanceslgiveup(e){
      var that = this
      that.checkeddef = false
      that.sendmethod = 2
      that.Tips = false
    },

    handleCanceslcontinue(){
      var that = this
      that.checkeddef = true
      that.sendmethod = 1
      that.Tips = false
    },
    onChangeqw () {
      this.disabledlook = false
    },

    unpdeteSubmit () {
      order_orderList({ id: 1, price: 0.01 }).then(response => {
        console.log(response)
      })
    },

    boglook () {
      // console.log('关闭3')
      this.companyname = this.form.getFieldValue('company')
      this.companyyscode = this.form.getFieldValue('yscode')
      console.log(this.companyyscode)
      if (this.companyyscode == undefined || this.companyyscode == '') {
        this.$message.warning('请填写信用代码！')
        return false
      } else {
        company_servicetime({
          yscode: this.companyyscode
        }).then((response) => {
          // console.log('+++', response.is)
          this.vshow = response.data.is
          this.outtime = response.data.time
          //倒数10秒
          let time = 10
          this.btnTime = setInterval(() => {
            if (time == 0) {
              clearInterval(this.btnTime)
              this.valiBtn = '同意条款'
              this.disabled = false
            } else {
              this.disabled = true
              this.valiBtn = '同意条款' + time
              time--
            }
          }, 1000)
          this.visible = true
        })

      }
    },

    handleOk (e) {
      this.visible = false
      console.log(this.vshow)
      if (this.vshow) {
        this.visiblelook = true
      }

      this.checked = true
    },

    handleOklook () {
      this.disabledlook = false
      this.visiblelook = false
    },

    handleCancel (e) {
      this.checked = false
      this.visible = false
      clearInterval(this.btnTime)
    },
    handleCancellook () {
      this.disabledlook = true
      this.visiblelook = false
    },

    onChangeq (e) {
      // console.log(e)
      console.log(`checked = ${e.target.checked}`)
    },

    onChange (a, b, c) {
      console.log(a, b, c)
    },

    //
    onChanges (value) {
    },
    handleSubmits(){
      this.$router.push('/login');
    },
    handleSubmit (e) {

      if (this.checked == false) {
        this.boglook()
        return false
      } else {

        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            // 判断是否为条码支付
            if (!this.$refs.payTestBarCode.getVisible() && (this.currentWayCode === 'WX_BAR' || this.currentWayCode === 'ALI_BAR' || this.currentWayCode === 'AUTO_BAR')) {
              this.$refs.payTestBarCode.showModal()
              return
            }

            const that = this
            values.paymenthod='ALI_QR'
            values.isdaiban=2;
            values.drawer=this.valueaw
            values.sendmethod = this.sendmethod
            values.paymenthod="ALI_QR"
            values.optype= 'pc'
            console.log(values)
            payTestOrder(values).then(res => {
              // console.log(res)
                that.$refs.payTestModal.showModal(this.currentWayCode, res.data) // 打开弹窗
                that.randomOrderNo() // 刷新订单号


            }).catch(() => {
              that.$refs.payTestBarCode.processCatch()
              that.randomOrderNo() // 刷新订单号
            })

          }
        })

      }

    },
    handleSelectChange (value) {
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      })
    },
    // 支付板块是否展示
    payTestShow () {
      // 如果未选择appid，或者支付方式列表为0，则不显示支付体验板块
      if (this.appId === '' || this.appPaywayList.length === 0) {
        return false
      } else {
        return true
      }
    },

    changeCurrentWayCode (wayCode, currentPayDataType) { // 切换支付方式
      this.currentWayCode = wayCode
      this.currentPayDataType = currentPayDataType
    },

    // 变更 appId的事件
    changeAppId (value) {
      this.appPaywayListHandle(value) // 根据appId的值，动态显示支付方式
    },

    // 刷新订单号
    randomOrderNo () {
      this.mchOrderNo = 'M' + new Date().getTime() + Math.floor(Math.random() * (9999 - 1000) + 1000)
    },

    // 获取条码的值
    barCodeChange (value) {
      this.authCode = value
      this.immediatelyPay()
    },

    // 根据不同的appId展示不同的支付方式(在下拉框切换时和在携带参数进入页面时调用)
    appPaywayListHandle (value) {
      if (!value) {
        this.appPaywayList = []
        return false
      }
      const that = this
      payTest(value).then(res => {
        that.appPaywayList = res.data
        if (res.length === 0) {
          that.noConfigText = true
        } else {
          that.noConfigText = false
        }
      })
    },
    // 立即支付按钮
    immediatelyPay () {
      // 判断支付金额是否为0
      if (!this.paytestAmount || this.paytestAmount === 0.00) {
        return this.$message.error('请输入支付金额')
      }

      // 判断是否选择支付方式
      if (this.currentWayCode === '') {
        return this.$message.error('请选择支付方式')
      }

      // 请输入订单标题
      if (!this.orderTitle || this.orderTitle.length > 20) {
        return this.$message.error('请输入正确的订单标题[20字以内]')
      }

      // 判断是否为条码支付
      if (!this.$refs.payTestBarCode.getVisible() && (this.currentWayCode === 'WX_BAR' || this.currentWayCode === 'ALI_BAR' || this.currentWayCode === 'AUTO_BAR')) {
        this.$refs.payTestBarCode.showModal()
        return
      }

      const that = this
      payTestOrder({
        // jsapi 默认使用聚合二维码支付
        wayCode: (this.currentWayCode === 'WX_JSAPI' || this.currentWayCode === 'ALI_JSAPI') ? 'QR_CASHIER' : this.currentWayCode, // 支付方式
        amount: this.paytestAmount, // 支付金额
        appId: this.appId, // appId
        mchOrderNo: this.mchOrderNo, // 订单编号
        payDataType: this.currentPayDataType, // 支付参数（二维码，条码）
        authCode: this.authCode,
        divisionMode: this.divisionMode,
        orderTitle: this.orderTitle
      }).then(res => {
        that.$refs.payTestModal.showModal(this.currentWayCode, res.data) // 打开弹窗
        that.randomOrderNo() // 刷新订单号
      }).catch(() => {
        that.$refs.payTestBarCode.processCatch()
        that.randomOrderNo() // 刷新订单号
      })
    },

    // 此处判断，微信，支付宝，聚合码，哪种支付方式一个都没配置，如果未配置，则不显示该板块，若等于-1 则表示不存在
    showTitle (parameterA) {
      if (this.appPaywayList.toString().indexOf(parameterA) === -1) {
        return false
      } else {
        return true
      }
    },
    // 聚合支付标题显示
    showQtTitle () {
      if (this.appPaywayList.toString().indexOf('WX') !== -1 || this.appPaywayList.toString().indexOf('ALI') !== -1 || this.appPaywayList.toString().indexOf('PP_PC') !== -1) {
        return true
      } else {
        return false
      }
    },

    // 自定义金额输入框是否展示
    amountInputShow () {
      this.$nextTick(() => { // 输入框默认展示焦点
        this.$refs.amountInputFocus.focus()
      })
      this.amountInput = true
      this.paytestAmount = ''
    },

    // 条码弹窗点击x或者蒙版关闭
    testCodeChange () {
      this.randomOrderNo() // 刷新订单号
    }

    // handleCloseBarCode () {
    //   this.$refs.payTestBarCode.visible = false
    // }
  }
}
</script>

<style lang="css" scoped>
@import '../../components/heard/pay.css';

body{
  background-color: #f0f2f5 !important;
}
/*html, body, #app, #root{background: #f5f5f5 !important;}*/

/*.son{*/
/*  position: absolute;*/
/*  left: 52px;*/
/*}*/
b {
  color: #333;
}

.wps {
  display: flex;
  justify-content: center;
  /*background: #132b75;*/
  height: 110px;
  line-height: 110px;
  /*padding: 25px 0;*/
  text-align: center;
  /*background: -webkit-radial-gradient(circle, #fff, #64d1dd, #e86a43);  */
  /*background:white; background-image: linear-gradient(90deg, rgba(200,0,0,.5) 50%, transparent 0), linear-gradient( rgba(200,0,0,.5) 50%, transparent 0); background-size: 30px 30px;*/
}

.boxw {
  display: block;
  width: 100px;
  height: 100px;
  font-size: 46px;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;
}


.biaoti {
  display: flex;
  flex-direction: row;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.shangpinbiaoti {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
}


.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}
.infotip{text-indent: 30px;line-height: 2}
.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}
#btnseal:hover{color: red}
#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}
.dingwei{
  width: 300px;
  height: 170px;
  position: absolute;
  top: -4px;
  right: 310px;

}
.colwei{
  width: 300px;
  height: 120px;
  background:#f5f5f5 ;
}
.dingweisb{
  /*width: 157px;*/

  position: absolute;
  top: 162px;
  left: 731px;

}


.position{
  background: rgba(0,0,0,.7);
  position:fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999 !important;
}

.position_cont{
  display: block;
  width: 500px;
  /*height: 200px;*/
  padding:0 25px;
  box-sizing: border-box;
  background: #fff;
  position:fixed;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  margin-top:-125px;
  margin-left:-225px;
  z-index: 1000 !important;
}

.position_conttit{
  display: block;
  /*height: 50px;*/
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_content{
  display: block;
  /*height: 100px;*/
  color: #f00;
  font-weight: bold;
  font-size: 14px;
  line-height: 70px;
  padding: 15px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.position_contbot{
  display: flex;
  justify-content: flex-end;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_contbot span{
  display: block;
  height: 35px;
  line-height: 20px;
  padding: 7px 25px;
  color: #fff;
  margin-top: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  background:#4278ff;
}
</style>
